import type { ChartSettings } from './types';

export const VIEWBOX = { minX: -250, minY: -260, width: 2100, height: 2200 };
export const INITIAL_SUN_X = 900;
export const INITIAL_SUN_Y = 800;
export const G_R = 490;
export const G_ANG = [-90, 0, 60, 126, 202];
export const G_R_OVERRIDE = [460, 480, 490, 720, 660];
export const P_R = 130;
export const G_DISC = 80;
export const P_DISC = 54;
export const ORBIT1_R = 140;
export const ORBIT2_R = 80;

export const DEFAULT_SETTINGS: ChartSettings = {
  title: 'ITPMS Program Org Chart',
  meta: 'TO #70CTD020FR0000280 · ICE HSI OCIO · Org Chart 20260305',
  labelMode: 'auto', nameSize: 11, roleSize: 9.5, dotSize: 6, sunR: 88,
  showRoles: true, showPills: true, showSpokes: true, showRings: true,
  showVacBox: true, animate: true,
  accent: '#0A5F8C', teal: '#0E7B72', slate: '#3A5068', bg: '#E9EFF6',
  wireColor: '#33465E', wireWidth: 1.6, wireDash: '', wireArrow: 'none',
  ringWidth: 1.6, ringDash: '5 5', ringSpeed: 24, ringSpin: 'normal',
  groupFill: '#FFFFFF', groupText: '#0B1220', groupFont: 13,
  progFill: '#FFFFFF', progText: '#0B1220', progFont: 11,
  labelDist: 22,
};
